import { ensure } from "sprint-common-web";

import { ContentSubtype } from "../../../../../../common/types/ContentSubtype";
import { LookupOrderItem } from "../../../../lookup-order/LookupOrderItem";
import { useSetLookupContent } from "../hooks/useSetLookupContent";

export const useAssociateLookupOrders = () => {
    const { setMovieContent, setTvContent, setAncillaryContent } = useSetLookupContent();

    const setContentFromLookupOrders = (item: LookupOrderItem) => {
        ensure(item.content);
        switch (item.content.subtype) {
            case ContentSubtype.Movie:
            case ContentSubtype.TvSingle:
            case ContentSubtype.FeatureDocumentary:
            case ContentSubtype.ShortFilm: {
                setMovieContent(item.content.movie.id, [item.content.version.id]);

                break;
            }

            case ContentSubtype.TV: {
                setTvContent({
                    tvSeriesId: item.content.tvSeries.id,
                    seasonId: item.content.season.id,
                    episodeId: item.content.episode.id,
                    versionIds: [item.content.version.id]
                });

                break;
            }

            case ContentSubtype.Promo:
            case ContentSubtype.Advert:
            case ContentSubtype.Safety:
            case ContentSubtype.ClientSpecific:
            case ContentSubtype.IndentWarning: {
                ensure(item.airline);
                setAncillaryContent(item.content.ancillary.id, item.airline);

                break;
            }
        }
    };

    return { setContentFromLookupOrders };
};
